import { render, staticRenderFns } from "./cvc-migration-readiness.vue?vue&type=template&id=3538445c"
import script from "./cvc-migration-readiness.vue?vue&type=script&lang=js"
export * from "./cvc-migration-readiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports